module.exports = __webpack_public_path__ + "img/syukyaku-top-g001sp.54c29d57.png";